module.exports = __webpack_public_path__ + "f1423f71e9116d1ac9b8310322151bde.png";


//////////////////
// WEBPACK FOOTER
// ../images/publisher/profile/no-active.png
// module id = 1061
// module chunks = 69